import Box from '@mui/material/Box';
import { BannerFrameSVGProps } from 'src/pages/video-banner-preview';

export function RightMiddle({
  height,
  width,
}: Omit<BannerFrameSVGProps, 'height'> & { height: string | number }) {
  //const viewHeight = height - 1;
  const viewWidth = width - 1;
  const svg = (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${viewWidth} 450`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      {/* <g filter="url(#filter0_f_14030_182098)">
        <path
          d={`M3 0V${height / 2 - 30} M3 ${height / 2 + 30}V${height}`}
          stroke="#0064E9"
        />
      </g> */}
      <path
        d={`M25 0V${1000}`}
        stroke="url(#paint0_linear_14030_182098)"
        strokeWidth="6"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_f_14030_182098"
          x="0.419922"
          y="-0.000976562"
          width={width}
          height={1000}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1"
            result="effect1_foregroundBlur_14030_182098"
          />
        </filter>
        <linearGradient
          id="paint0_linear_14030_182098"
          x1="-644.129"
          y1="-129"
          x2="-644.129"
          y2="556.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#45C6FF" />
          <stop offset="1" stopColor="#0064E9" />
        </linearGradient>
      </defs>
    </svg>
  );
  return <Box>{svg}</Box>;
}
